/**
 * 如果一个函数运行起来非常的消耗资源，想把它拆分成多段，可以一点点的运行，那么就试试看这个。
 *
 * 只需要把原来的函数（可以是异步函数）的函数名前加个星号，然后在可以喘息的地方，加一个 `yield` 就行
 *
 * 当然，这个函数会导致 resolve 的比较慢，毕竟会把之前连续执行的函数分拆成一小段时间执行一点的样子。
 *
 * 例子：
 *
 * ```js
 * // 注意函数名字前面有个星号
 * async function *veryExpensiveFn(name) {
 *   const answer = []
 *
 *   for (const ch of name) {
 *     const xx = calculateSomethingSlowly(ch)
 *     answer.push(xx)
 *
 *     yield  // 在这里喘息，避免这个函数占用太长执行时间
 *   }
 *
 *   return answer
 * }
 *
 * // 在使用的地方
 *
 * const answer = await resolveGenerator(veryExpensiveFn('hello'))
 * ```
 */
export function resolveGenerator(generator, opts) {
  var _opts$tickDuration, _opts$tickInterval;
  let aborted;
  let flushing = false;
  let forceNextTick;
  const tickDuration = (_opts$tickDuration = opts === null || opts === void 0 ? void 0 : opts.tickDuration) !== null && _opts$tickDuration !== void 0 ? _opts$tickDuration : 200;
  const tickInterval = (_opts$tickInterval = opts === null || opts === void 0 ? void 0 : opts.tickInterval) !== null && _opts$tickInterval !== void 0 ? _opts$tickInterval : 100;
  const promise = new Promise((resolve, reject) => {
    const nextTick = async () => {
      const timeUbound = performance.now() + tickDuration;
      forceNextTick = undefined;
      try {
        do {
          if (aborted) {
            const ans1 = await generator.throw(aborted);
            resolve(ans1.value);
            return;
          }
          const ans = await generator.next();
          if (ans.done) {
            resolve(ans.value);
            return;
          }
        } while (flushing || performance.now() < timeUbound);
      } catch (err) {
        reject(err);
        return;
      }
      const timer = setTimeout(nextTick, tickInterval);
      forceNextTick = () => {
        clearTimeout(timer);
        nextTick();
      };
    };
    nextTick();
  });
  return {
    promise,
    abort() {
      var _forceNextTick;
      aborted = new Error('ResolveGenerator Aborted');
      (_forceNextTick = forceNextTick) === null || _forceNextTick === void 0 || _forceNextTick();
    },
    flush() {
      var _forceNextTick2;
      flushing = true;
      (_forceNextTick2 = forceNextTick) === null || _forceNextTick2 === void 0 || _forceNextTick2();
      return promise;
    }
  };
}
//# sourceMappingURL=resolveGenerator.js.map
